import styled from 'styled-components';
import { MapButtonSmall } from 'ff/debrief/common/components/StyledComponents/Buttons';
import { useDebriefDispatch, useMapSettings } from 'ff/debrief/hooks';
import {
    toggleMapSetting,
    toggleShowAirports,
} from 'ff/debrief/features/MapSlice';
import Airports from 'ff/debrief/common/components/FFMap/icons/Airports';
import Waypoints from 'ff/debrief/common/components/FFMap/icons/Waypoints';
import Navaids from 'ff/debrief/common/components/FFMap/icons/Navaids';
import Airways from 'ff/debrief/common/components/FFMap/icons/Airways';
import React from 'react';
import Airspaces from 'ff/debrief/common/components/FFMap/icons/Airspaces';
import Divider from '@mui/material/Divider';
import { SettingName } from 'ff/debrief/models';

export const CustomMapButton = styled(MapButtonSmall)`
    cursor: pointer;
    height: 32px;
    margin: 0 !important;
    width: 32px;
    padding-left: 6px;
    padding-right: 6px;
`;

export const CustomMapButtonGroup = styled.div`
    > * {
        &:first-child {
            border-radius: 4px 4px 0 0;
        }
        &:last-child {
            border-radius: 0 0 4px 4px;
        }
    }
`;

export const AeroToggleButtons = () => {
    const { currentSettings } = useMapSettings();
    const dispatch = useDebriefDispatch();

    const handleClick = (setting: SettingName, value: boolean) => {
        dispatch(toggleMapSetting({ settingName: setting, value }));
    };
    return (
        <CustomMapButtonGroup>
            <CustomMapButton
                $isActive={Boolean(currentSettings?.airports)}
                onClick={() => dispatch(toggleShowAirports())}
            >
                <Airports css="max-width: 15px" />
            </CustomMapButton>
            <Divider variant="middle" />
            <CustomMapButton
                $isActive={Boolean(currentSettings?.airspace)}
                onClick={() =>
                    handleClick('airspace', !currentSettings?.airspace)
                }
            >
                <Airspaces css="max-width: 13px" />
            </CustomMapButton>
            <Divider variant="middle" />
            <CustomMapButton
                $isActive={currentSettings?.filters?.waypoints}
                onClick={() =>
                    handleClick(
                        'waypoints',
                        !currentSettings?.filters?.waypoints
                    )
                }
            >
                <Waypoints css="max-width: 13px" />
            </CustomMapButton>
            <Divider variant="middle" />
            <CustomMapButton
                $isActive={currentSettings?.filters?.navaids}
                onClick={() =>
                    handleClick('navaids', !currentSettings?.filters?.navaids)
                }
            >
                <Navaids />
            </CustomMapButton>
            <Divider variant="middle" />
            <CustomMapButton
                $isActive={Boolean(currentSettings?.filters?.airways)}
                onClick={() =>
                    handleClick('airways', !currentSettings?.filters?.airways)
                }
            >
                <Airways />
            </CustomMapButton>
        </CustomMapButtonGroup>
    );
};
